import React from "react";
import { ModalWrapper, ModalContainer, CloseButton } from "./CustomModalStyles";

const CustomModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <ModalWrapper>
      <ModalContainer>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        {children}
      </ModalContainer>
    </ModalWrapper>
  );
};

export default CustomModal;